import {
  getPedidoPdfById,
  postPresupuestoGenerateExcel,
} from "api/Pedido.service"
import { TipoDocumentoComercialType } from "api/Types/TipoDocumentoComercial"
import { handleDirectDownloadExcel } from "common/context/DownloadFileProvider"
import notification from "common/utils/notification"
import { TFunction } from "i18next"
import fileDownload from "js-file-download"
import { Dispatch, SetStateAction } from "react"

export const handleDownloadPdfPedido = async (
  id: string,
  serie: string,
  t: TFunction
) => {
  try {
    const { data } = await getPedidoPdfById(id)

    fileDownload(
      new Blob([data]),
      `${t("types.order")}${serie ? `_${serie}` : ""}.pdf`
    )

    notification.success({ body: `${t("successMsg.downloadDocument")}` })
  } catch (error) {
    notification.errorServidor({
      body: `${t("errorMsg.downloadDocument")}`,
    })
  }
}

export const handlerExportPedidosToExcel = async (
  tipoDocumentoComercial: TipoDocumentoComercialType,
  setIsLoadingExport: Dispatch<SetStateAction<boolean>>,
  t: TFunction
) => {
  try {
    setIsLoadingExport(true)
    const { data } = await postPresupuestoGenerateExcel({
      tipoDocumentoComercial,
    })
    handleDirectDownloadExcel(data, `${t("types.order")}.xlsx`)
  } catch (err) {
    notification.errorServidor({
      body: `${t("crear.pedido.msg.downloadFail")}`,
    })
  } finally {
    setIsLoadingExport(false)
  }
}
